import { supabase } from './supabaseClient';

/**
 * A short-lived link to a signed agreement.
 *
 * These were public object URLs: legal-docs is a public bucket, so the PDF —
 * which carries the signer's name, email and IP — was readable by anyone with
 * the link. The file name being a UUID is obscurity, not access control.
 *
 * A signed URL is checked against storage policy at the moment it is created,
 * so only the stylist it belongs to or an active admin can get one, and it
 * stops working shortly afterwards.
 */
export async function legalDocUrl(path, { expiresIn = 300 } = {}) {
  if (!path) return null;
  // Rows written before the bucket existed hold a full URL already.
  if (String(path).startsWith('http')) return String(path);

  const clean = String(path).replace(/^\/+/, '');
  const { data, error } = await supabase.storage
    .from('legal-docs')
    .createSignedUrl(clean, expiresIn);

  if (error) {
    console.warn('Could not sign the legal document URL:', error.message);
    return null;
  }
  return data?.signedUrl ?? null;
}

/** Signs the document, then opens it. Used where a plain href cannot wait. */
export async function openLegalDoc(path) {
  const url = await legalDocUrl(path);
  if (url) {
    window.open(url, '_blank', 'noopener,noreferrer');
  } else {
    window.alert('That document could not be opened. You may not have access to it.');
  }
}
